import { Menu, MenuItem, MenuList } from '@mui/material'
import PopupState, { bindMenu, bindTrigger } from 'material-ui-popup-state'
import { Fragment } from 'react/jsx-runtime'
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded'
import DeleteModal from '../modals/DeleteModal'
import MovePoolModal from '../modals/MovePoolModal'

export default function PopupMenuList({ task_id, study_id }: { task_id: string; study_id: string }) {
  return (
    <PopupState variant="popover">
      {(popupState) => (
        <Fragment>
          <MoreVertRoundedIcon
            fontSize="small"
            {...bindTrigger(popupState)}
            sx={{
              cursor: 'pointer',
              '&:hover': {
                borderRadius: '50%',
                backgroundColor: '#F3F4F6',
              },
            }}
            data-testid="popup-menu-icon"
          />
          <Menu
            {...bindMenu(popupState)}
            anchorOrigin={{
              vertical: 'center',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            data-testid="popup-menu-list"
          >
            <MenuList
              sx={{
                width: 251,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                paddingY: 0.5,
                outline: 'none',
              }}
            >
              <MenuItem
                sx={{
                  width: '100%',
                }}
                data-testid="popup-menu-list-item-reopen"
              >
                <MovePoolModal task_id={task_id} study_id={study_id} popupState={popupState} />
              </MenuItem>
              <MenuItem
                sx={{
                  width: '100%',
                }}
                data-testid="popup-menu-list-item-reset"
              >
                <DeleteModal taskIds={[task_id]} study_id={study_id} popupState={popupState} />
              </MenuItem>
            </MenuList>
          </Menu>
        </Fragment>
      )}
    </PopupState>
  )
}
